import axios from "axios";

const API = `${process.env.REACT_APP_API_URL}/reviews`;

const authHeader = () => ({
  "x-user-token": localStorage.getItem("userToken") || ""
});

export const getBusinessReviews = async (businessId) => {
  const res = await axios.get(`${API}/${businessId}`);
  return res.data;
};

export const createReview = async (businessId, rating, comment) => {
  const res = await axios.post(
    API,
    { businessId, rating, comment },
    { headers: authHeader() }
  );
  return res.data;
};

export const deleteMyReview = async (reviewId) => {
  const res = await axios.delete(`${API}/${reviewId}`, { headers: authHeader() });
  return res.data;
};
